import api from "./api";

// ── Current Plan / Expiry Check ─────────────────────────────────────────────

/**
 * Fetches the current subscription status.
 * Returns:
 *  { success, has_plan, show_popup, message }          — when no active plan
 *  { success, has_plan, message, data: { ...plan } }   — when plan exists
 */
export async function getCurrentPlan() {
  try {
    const res = await api.get("subscriptions/current-plan/");
    return res.data;
  } catch (err) {
    console.error("Error fetching current plan:", err);
    return { success: false, has_plan: false, show_popup: false };
  }
}

// ── Request Free Plan Extension ─────────────────────────────────────────────

/**
 * Sends a request to extend the free plan.
 * Backend should record the request and notify admin.
 */
export async function requestPlanExtension() {
  try {
    const res = await api.post("subscriptions/free-plan-extenssion/");
    return res.data;
  } catch (err) {
    throw err;
  }
}